import React, { useState } from 'react';
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from '../components/Modal';  // Importer le composant Modal

const Gorille = () => {
  const images = [
    '7.jpg',
    'gorille5.jpg',
    'gorille6.jpg',
    'gorille7.jpg',
    'gorille8.jpg',
    'gorille9.jpg',
    'gorille10.jpg',
    'gorille11.jpg',
    'gorille12.jpg',


   

    // Ajoute ici toutes les autres images
  ];

  const [modalImage, setModalImage] = useState(null);  // État pour l'image du modal
  const [modalAltText, setModalAltText] = useState("");  // État pour le texte alternatif de l'image

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  return (
    <div className="album-detail">
      <h1>Album Gare au gorille</h1>
      <div className="image-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={`/album/gorille/${image}`}
            alt={`Détail de l'image ${index + 1}`}  // Descriptions concises pour l'accessibilité
            className="album-image"
            onClick={() => openModal(`/album/gorille/${image}`, `Détail de l'image ${index + 1}`)}  // Ouvre en grand
          />
        ))}
      </div>

      {/* Affichage du Modal lorsque l'image est cliquée */}
      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Gorille;
